import { render, staticRenderFns } from "./Madden23.vue?vue&type=template&id=bd67cd16&lang=pug&"
import script from "./Madden23.vue?vue&type=script&lang=js&"
export * from "./Madden23.vue?vue&type=script&lang=js&"
import style0 from "../assets/themes/madden23/scss/main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports